import React, { useState } from 'react';
import PropTypes from 'prop-types';
import YesNoButton from 'components/common/YesNoButton';

import { CancelIcon, CircleCheckIcon as CheckCircleIcon, InfoIcon, WarningIcon, QuestionIcon } from 'components/icons';

const icons = {
	error: CancelIcon,
	info: InfoIcon,
	question: QuestionIcon,
	success: CheckCircleIcon,
	warning: WarningIcon,
};

const ConfirmDialog = props => {
	const {
		className = '',
		classNameCloseButton = '',
		classNameIcon = '',
		classNameYesNoContainer,
		classNameYesButton,
		classNameNoButton,
		checkbox,
		message,
		note,
		onYes,
		onNo,
		onClose,
		severity = 'question',
	} = props;

	// the optional checkbox starts unchecked (each confirm() shows a new instance, see context/confirm.js)
	const [checked, setChecked] = useState(false);

	const icon = <span className={classNameIcon}>{icons[severity]}</span>;
	const action = (
		<YesNoButton
			classNameContainer={classNameYesNoContainer}
			classNameYesButton={classNameYesButton}
			classNameNoButton={classNameNoButton}
			onNo={onNo}
			onYes={checkbox ? () => onYes(checked) : onYes}
		/>
	);

	// without a checkbox or a note the message is the same single span as ever, for every other caller
	let body = <span>{message}</span>;
	if (checkbox || note) {
		body = (
			<div className="flex flex-col gap-3">
				<span>{message}</span>
				{note ? <span className="text-base text-white/80">{note}</span> : null}
				{checkbox ? (
					<label className="flex flex-row items-center gap-2 py-2 text-base">
						<input
							type="checkbox"
							className="h-5 w-5 shrink-0"
							checked={checked}
							onChange={event => setChecked(event.target.checked)}
						/>
						<span>{checkbox.label}</span>
					</label>
				) : null}
			</div>
		);
	}

	let closeicon;
	if (onClose) {
		closeicon = (
			<button className={classNameCloseButton} onClick={onClose}>
				x
			</button>
		);
	}

	return (
		<div className={className}>
			{icon}
			{body}
			{action}
			{closeicon}
		</div>
	);
};

ConfirmDialog.propTypes = {
	// eslint-disable-next-line react/require-default-props -- optional, read from props; React 18.3 deprecates defaultProps on function components
	checkbox: PropTypes.shape({ label: PropTypes.string.isRequired }),
	className: PropTypes.string,
	classNameCloseButton: PropTypes.string,
	classNameIcon: PropTypes.string,
	classNameYesNoContainer: PropTypes.string,
	classNameYesButton: PropTypes.string,
	classNameNoButton: PropTypes.string,
	handleClose: PropTypes.func,
	message: PropTypes.string.isRequired,
	// eslint-disable-next-line react/require-default-props -- optional, read from props; React 18.3 deprecates defaultProps on function components
	note: PropTypes.string,
	onClose: PropTypes.func,
	onNo: PropTypes.func.isRequired,
	onYes: PropTypes.func.isRequired,
	severity: PropTypes.oneOf(['error', 'info', 'success', 'warning', 'question']),
};

export default ConfirmDialog;
